module.exports = __webpack_public_path__ + "static/media/hayon4.ceec6e73.jpg";